import ReplacementHandoffPanel from "./replacementHandoffPanel.container";

export default ReplacementHandoffPanel;
